const HeaderPaymentHistory = ['Date', 'Total Pay', 'Action'];

export { HeaderPaymentHistory };
